import { RandomGenerator } from '@wix/answers-api';
import { GenAiArticleLink } from '../types';

export const randomArticle = RandomGenerator.article();
const anotherRandomArticle = RandomGenerator.article();

export const genAnswerMock = {
    search_term: 'How to connect a domain?',
    solution: 'To connect a domain you already own to your Wix site, follow these steps:\n\n<p>1. **Upgrade your Wix site** with a plan.\n2. Go to the <a href="https://manage.wix.com/wix/api/mpContainerStaticController#/domains">Domains</a> section in your Wix account.\n3. Click **Add an Existing Domain** and select **Connect a domain you already own**.\n4. Enter your domain name and follow the prompts to connect it.\n</p>\nYou can connect via **name servers** (recommended) or **pointing**. If you choose to use name servers, you will need to update them in your domain host account as instructed. \n\nPlease note that it may take up to **48 hours** for the changes to propagate. For more details, you can refer to the articles on connecting via name servers and pointing methods.',
    used_articles: ['Connecting or Transferring a Domain Purchased Elsewhere to Your Wix Account' , 'Connecting or Transferring a Domain Purchased Elsewhere to Your Wix Account'],
};

export const mockArticleLinks: GenAiArticleLink[] = [
    {
        articleId: randomArticle.id,
        articleName: randomArticle.title,
        articleURL: randomArticle.url,
        distance: 0.6736897368796387,
    },
    {
        articleId: anotherRandomArticle.id,
        articleName: anotherRandomArticle.title,
        articleURL: anotherRandomArticle.url,
        distance: 0.368796387,
    },
];
